<template>
  <div v-if="visible" class="modal">
    <div class="modal-content">
      <span class="close" @click="close">&times;</span>
      <h3>Detalles de No Entregados</h3>
      <div class="table-container">
        <vue-good-table
          :columns="columns"
          :rows="noEntregadosData"
          :pagination-options="{
            enabled: true,
            mode: 'pages',
            nextLabel: 'Siguiente',
            prevLabel: 'Anterior',
            rowsPerPageLabel: 'Filas por página',
            ofLabel: 'de',
            pageLabel: 'Página',
            allLabel: 'Todo',
          }"
          :search-options="{
            enabled: true,
            placeholder: 'Buscar',
          }"
          :line-numbers="true"
        >
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import { BFormSelect } from "bootstrap-vue";

export default {
  components: {
    VueGoodTable,
    BFormSelect,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    noEntregadosData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      columns: [
        {
          label: "DNI",
          field: "dni",
          sortable: true,
          filterable: true,
          width: "100px",
        },
        {
          label: "Nombre",
          field: "nombre",
          sortable: true,
          filterable: true,
          width: "150px",
        },
        {
          label: "Apellidos",
          field: "apellidos",
          sortable: true,
          filterable: true,
          width: "200px",
        },
        {
          label: "Sede",
          field: "sede",
          sortable: true,
          filterable: true,
          width: "100px",
        },
        {
          label: "Posición",
          field: "posicion",
          sortable: true,
          filterable: true,
          width: "200px",
        },
        {
          label: "Área",
          field: "area",
          sortable: true,
          filterable: true,
          width: "150px",
        },
        {
          label: "Absentismo",
          field: "ausente",
          sortable: true,
          filterable: true,
          width: "150px",
        },
      ],
      paginationOptions: {
        enabled: true,
        perPage: 10,
      },
      perPageOptions: [
        { value: 10, text: "10" },
        { value: 20, text: "20" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      translations: {
        noResults: "No se encontraron resultados",
        search: "Buscar",
        rowsPerPage: "Filas por página",
        page: "Página",
        of: "de",
        next: "Siguiente",
        prev: "Anterior",
        all: "Todo", // Para cuando se selecciona 'All' en la paginación
      },
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style>


</style>